import { Box, Tabs as MuiTabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Form = styled('form')(() => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const ButtonsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  width: '440px',
  maxWidth: '100%',
  alignSelf: 'center',

  [theme.breakpoints.down(800)]: {
    marginTop: 'auto',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    width: '100%',
  },
}));

export const InputsWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: 'grid',
  gridTemplateAreas: `
    "container container metrics"
    "settings settings metrics"
  `,
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: 'auto 1fr',
  gap: '32px 20px',
  marginBottom: '40px',
  overflow: 'hidden',

  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateAreas: `
      "container container metrics metrics"
      "settings settings metrics metrics"
  `,
    gap: '32px 40px',
  },

  [theme.breakpoints.down(800)]: {
    flexGrow: 'unset',
    gridTemplateColumns: '1fr',
    gridTemplateAreas: `
      "container"
      "metrics"
      "settings"
  `,
    gridTemplateRows: 'auto auto auto',
    gap: '30px 0',
  },

  [theme.breakpoints.down('sm')]: {
    marginBottom: '30px',
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  gridArea: 'container',
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  gridColumn: 'span 2',
  marginRight: '20px',

  [theme.breakpoints.down('lg')]: {
    marginRight: '0px',
  },

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
  },
}));

export const FormulaSettings = styled(Box)(({ theme }) => ({
  gridArea: 'settings',
  display: 'flex',
  flexDirection: 'column',
  padding: '15px 10px 15px 15px',
  marginRight: '20px',
  border: '1px solid rgba(221, 221, 234, 1)',
  borderRadius: '6px',
  overflowY: 'hidden',

  [theme.breakpoints.down('lg')]: {
    marginRight: '0px',
  },
}));

export const Tabs = styled(MuiTabs)(({ theme }) => ({
  minHeight: '34px',
  margin: '0 5px 20px 0',

  '.MuiTabs-flexContainer': {
    gap: '20px',
  },

  '.Mui-selected': {
    background: 'rgba(201, 255, 235, 1)',
  },

  '.MuiTab-root': {
    flex: '1 1 0',
    padding: '5px 10px',
    minHeight: 'unset',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 700,
    borderRadius: '6px',
    textTransform: 'none',
  },

  [theme.breakpoints.down('lg')]: {
    '.MuiTabs-flexContainer': {
      gap: '10px',
    },
  },

  [theme.breakpoints.down('sm')]: {
    '.MuiTabs-flexContainer': {
      flexWrap: 'wrap',
    },
  },
}));
